import { ObjectDirective } from "@vue/runtime-core";

export const visible: ObjectDirective = {
  beforeMount(el, { value }, { transition }) {
    if (transition && value) {
      transition.beforeEnter(el);
    } else {
      el.style.visibility = "hidden";
    }
  },
  updated(el, { value, oldValue }, { transition }) {
    if (!value === !oldValue) {
      return;
    }
    if (value) {
      if (transition) {
        transition.beforeEnter(el);
        transition.enter(el);
      }
      el.style.visibility = "";
    } else {
      if (transition) {
        transition.leave(el, () => {
          return;
        });
      }
      el.style.visibility = "hidden";
    }
  }
};
